import React from "react";
import { Box } from "app/components/common";
import {
  isMediumWeb,
  isBigWeb,
  isWebDesktop,
} from "@microdoing/shared/utils/deviceDetectors";
import { WebHeader } from "../WebHeader";
import { IBreadCrumbPath } from "app/navigation/breadcrumb/types";
import {
  BIG_WEB_TAB_BAR_SIZE,
  MEDIUM_WEB_TAB_BAR_SIZE,
  SMALL_TAB_BAR_SIZE,
} from "app/Theme/Box/constants";

interface IProps extends IBreadCrumbPath {
  children: React.ReactElement;
}

let marginLeft = SMALL_TAB_BAR_SIZE;

if (isBigWeb) {
  marginLeft = BIG_WEB_TAB_BAR_SIZE;
} else if (isMediumWeb) {
  marginLeft = MEDIUM_WEB_TAB_BAR_SIZE;
}

const WebDesktopView = ({ breadcrumbsPath = [], children }: IProps) => {
  if (isWebDesktop) {
    return (
      <Box
        variant="webBoxing"
        marginTop={{ smallWeb: "sl", web: "webSL" }}
        marginBottom={{ smallWeb: "l", web: "webSL" }}
        style={{
          marginLeft,
        }}
      >
        <Box flex={1} height="100%" width="100%">
          <WebHeader breadcrumbsPath={breadcrumbsPath} />
          <Box flex={1} width="100%">
            {children}
          </Box>
        </Box>
      </Box>
    );
  }

  return children;
};

export default WebDesktopView;
